import { useEffect, useRef, useState } from 'react'
import { Button, ListDesktop, ListMobile, ModalCloseButton, ModalContent, ModalImage, ModalOverlay, ModalTitle1, ModalWindow, ModalWrapper } from './BlogSubscribePopup.styles'
// import subscribePromptWrapper from '../../assets/subscribePromptWrapper.png'
import closePopupImg from '../../assets/blog/blogClose.svg'
import subscribePromptWrapper from '../../assets/subscribePromptWrapper2.png'
import { logEvent } from '../../utils/firebase'

let timeout = null

export const BlogSubscribePopup = () => {
  const [email, setEmail] = useState('')
  const [success, setSuccess] = useState(null)
  const [isVisible, setIsVisible] = useState(false)
  const hiddenTimes = useRef(0)

  useEffect(() => {
    // const popup = sessionStorage.getItem('blogSubscribePopup')

    // if (popup === 'true') return

    setTimeout(() => {
      // sessionStorage.setItem('blogSubscribePopup', 'true')
      setIsVisible(true)
    }, 9000)
  }, [])

  const handleSubmit = async e => {
    e.preventDefault()

    if (!email) return

    const request = await fetch(`/api/subscribe?email=${email}`)

    if (request.status === 200) {
      setSuccess(true)
    } else {
      setSuccess(false)
    }
  }

  const handleClose = () => {
    setIsVisible(false)
    hiddenTimes.current++

    if (hiddenTimes.current < 1) {
      timeout = setTimeout(() => {
        setIsVisible(true)
      }, 20000)
    }
  }

  if (!isVisible) return null

  return (
    <>
      <ModalOverlay />
      <ModalWrapper>
        <ModalWindow>
          <ModalCloseButton onClick={handleClose}>
            <img src={closePopupImg} alt="Close window" width={12} height={12} />
          </ModalCloseButton>
          <ModalImage width={340} height={370} alt="" src={subscribePromptWrapper} alt="" />
          <ModalContent>
            <ModalTitle1 style={{ fontWeight: 'bold', fontSize: '18px' }}>Design Your Dream Room in Seconds!</ModalTitle1>
            <ModalTitle1>
              Join 10M users in <span>DecorMatters</span> App!
            </ModalTitle1>
            <ListDesktop>
              <li>Decorate Real Rooms</li>
              <li>Play Design Games</li>
              <li>Win Challenges & Rewards</li>
            </ListDesktop>
            <ListMobile>
              <li>Transform Spaces with AI</li>
              <li>Decorate Real Rooms</li>
              <li>Play Design Games</li>
            </ListMobile>
            <Button
              onClick={() => {
                logEvent('blog_modal_cta_clicked')
              }}
              href="https://decormatters.app.link/9LQKBxPfHQb"
              target="_blank"
            >
              Start Designing Now
            </Button>
            {/* <ModalTitle>NEVER MISS ANOTHER POST</ModalTitle>
            <ModalDescription>
              Sign up for the latest home decor trends, creative interior
              solutions, and design tips and hacks!
            </ModalDescription>
            <ModalInputWrapper method="post" onSubmit={handleSubmit}>
              <ModalInput
                required
                placeholder="Enter your email here"
                type="email"
                placeholder="Enter your email"
                name="EMAIL"
                id="mce-EMAIL"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <ModalInputButton disabled={success !== null}>
                {success === null ? 'Subscribe' : 'Thank you!'}
              </ModalInputButton>
            </ModalInputWrapper>
            <TryNowLine>
              <p>Try your own designs along with 10 million users.</p>
              <TryNowButton href="http://decormatters.app.link/blog">
                <span>Try Now</span>
              </TryNowButton>
            </TryNowLine> */}
          </ModalContent>
        </ModalWindow>
      </ModalWrapper>
    </>
  )
}
